module.exports = __webpack_public_path__ + "assets/images/icon-info.svg?v=8ab8461a";